
import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Logo from "./assets/logo.png";
import Icon from "./assets/Infiltration7.png";

export default function LandingPage() {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: "100vh",
        position: "relative",
        px: { xs: 1.5, sm: 2 },

        background: `
          radial-gradient(
            circle at top right,
            rgba(255, 200, 120, 0.22),
            transparent 55%
          ),
          radial-gradient(
            circle at bottom left,
            rgba(255, 180, 80, 0.18),
            transparent 60%
          ),
          linear-gradient(
            180deg,
            #ffffff 0%,
            #faf7f2 60%,
            #f3ede3 100%
          )
        `,
      }}
    >
      {/* ================= TOP BAR ================= */}
    <Box
  sx={{
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    height: 58,
    px: { xs: 2, sm: 3 },
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    zIndex: 1200,
  }}
>
  <img
    src={Logo}
    alt="Savy & Sons"
    style={{ width: "clamp(90px, 30vw, 140px)" }}
  />

 <Button
  onClick={() => navigate("/signin")}
  sx={{
    flexShrink: 0,

    // ✅ SIZE (this is the key part)
    height: 38,
    minWidth: 96,
    px: 3,              // horizontal padding
    py: 0,              // vertical handled by height

    fontSize: 14.5,
    fontWeight: 700,
    textTransform: "none",

    borderRadius: "999px",
    border: "1.8px solid #000",
    backgroundColor: "#fff",
    color: "#000",

    "&:hover": {
      backgroundColor: "#000",
      color: "#fff",
    },
  }}
>
  Login
</Button>


</Box>

      {/* ================= CENTER CONTENT ================= */}
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          pt: 7,
        }}
      >
        <Box
          sx={{
            width: "min(720px, 94vw)",
            borderRadius: 4,
            p: { xs: 3, sm: 4.5 },
            textAlign: "center",

            background: `
              linear-gradient(
                180deg,
                #fff7e6 0%,
                #ffffff 70%
              )
            `,
            border: "1px solid rgba(0,0,0,0.08)",
            boxShadow:
              "0 20px 50px rgba(0,0,0,0.16), 0 6px 14px rgba(0,0,0,0.08)",
          }}
        >
          {/* ================= HEADLINE ================= */}
          <Typography
            sx={{
              fontSize: { xs: 22, sm: 34 },
              fontWeight: 800,
              color: "#000",
              letterSpacing: -0.4,
              lineHeight: 1.15,
            }}
          >
            See How Much Inflow & Infiltration
            <br />
            Is Costing Your System
          </Typography>

          {/* ================= SUBHEAD ================= */}
          <Typography
            sx={{
              mt: 2,
              fontSize: { xs: 14.5, sm: 16 },
              color: "#444",
              maxWidth: 560,
              mx: "auto",
              lineHeight: 1.55,
            }}
          >
            Estimate I&amp;I costs and uncover potential savings in just a few
            minutes using real operational inputs.
          </Typography>

          {/* ================= WHO IT’S FOR ================= */}
          <Typography
            sx={{
              mt: 2.5,
              fontSize: 14,
              fontWeight: 600,
              color: "#7a5a20",
            }}
          >
          Designed for utilities, municipalities, and wastewater system operators

          </Typography>

          {/* ================= PRIMARY CTA ================= */}
          {/* <Button
            onClick={() => navigate("/ii-cost-savings")}
            sx={{
              mt: 4,
              px: 4,
              py: 1.3,
              fontSize: 15,
              fontWeight: 800,
              textTransform: "none",
              borderRadius: 3,
              background: "#f5c400",
              color: "#000",
              boxShadow: "0 10px 22px rgba(0,0,0,0.22)",
              "&:hover": {
                background: "#e5b800",
                transform: "translateY(-1px)",
                boxShadow: "0 14px 28px rgba(0,0,0,0.28)",
              },
            }}
          >
            Estimate My I&amp;I Costs
          </Button> */}
<Box
  sx={{
    display: "flex",
    justifyContent: "center",   // ✅ center horizontally
    alignItems: "center",
    mt: 4,
  }}
>
  <Button
    onClick={() => navigate("/ii-cost-savings")}
    sx={{
      px: 5,
      py: 2.6,
      fontSize: 15,
      fontWeight: 800,
      textTransform: "none",
      borderRadius: 3,
      background: "#F3C26B",
      color: "#000",
      boxShadow: "0 10px 22px rgba(0,0,0,0.22)",

      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: 1.2,                 // spacing between icon & text

      "&:hover": {
        background: "#F3C26B",
        transform: "translateY(-1px)",
        boxShadow: "0 14px 28px rgba(0,0,0,0.28)",
      },
    }}
  >
      <span
    style={{
      fontSize: 18,
      fontWeight: 900,
      letterSpacing: 0.3,
    }}
  >
   <span style={{ color: "#000" }}></span> ▶ CLICK HERE TO START
  </span>
    {/* BIG ICON */}
<img
  src={Icon}
  alt="I&I"
  style={{
    width: 210,          // increase width for clarity
    height: "auto",      // ✅ keep aspect ratio
    maxHeight: 70,       // prevents overgrowth
    objectFit: "contain",
    display: "block"
  }}
/>


    {/* TEXT */}
    <span style={{ textAlign: "center" }}>
     Estimate My I&amp;I Costs
    </span>
  </Button>
</Box>



          {/* ================= MICRO TRUST ================= */}
          <Typography
            sx={{
              mt: 1.5,
              fontSize: 13,
              color: "#666",
            }}
          >
            Free tool • No sign-up • Takes less than a minute
          </Typography>

          {/* ================= 3-STEP EXPLAINER ================= */}
          <Box
            sx={{
              mt: 4,
              display: "flex",
              justifyContent: "center",
              gap: { xs: 2, sm: 4 },
              flexWrap: "wrap",
            }}
          >
            {[
              "Enter system details",
              "Estimate I&I impact",
              "View potential savings",
            ].map((step, i) => (
              <Typography
                key={step}
                sx={{
                  fontSize: 13.5,
                  color: "#444",
                  fontWeight: 600,
                }}
              >
                {i + 1}. {step}
              </Typography>
            ))}
          </Box>

         {/* ================= DISCLAIMER ================= */}
<Box
  sx={{
    width: "100%",
    textAlign: "center",
    pb: 2.5,
    px: 2,
    mt: 6,
    color: "#7a7a7a",
    fontSize: 11.5,
    lineHeight: 1.6,
    fontStyle: "italic",
  }}
>
  Note:This calculator provides a high-level estimate based on the information entered.
  Actual costs, savings, and results may vary depending on system conditions,
  operational factors, and site-specific variables.
</Box>


          {/* ================= SUPPORTING VISUAL ================= */}
          {/* <Box
            sx={{
              mt: 4,
              display: "flex",
              justifyContent: "center",
              opacity: 0.85,
            }}
          >
            <Box
              sx={{
                width: { xs: 90, sm: 110 },
                height: { xs: 90, sm: 110 },
                borderRadius: 2.5,
                background: "#ffffff",
                boxShadow: "0 8px 18px rgba(0,0,0,0.12)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                p: 1.5,
              }}
            >
              <img
                src={Icon}
                alt="Inflow & Infiltration Analysis"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                }}
              />
            </Box>
          </Box> */}
        </Box>
      </Box>
    </Box>
  );
}
